import { Crypto } from '@/utils/crypto'
import { STORAGE_LOGIN_KEY, STORAGE_SIGNUP_KEY, STORAGE_RESET_KEY, STARAGE_SUGGESTIONS_KEY, MAX_VALID_STORAGE_MINUTE } from '@/config'
import { utils } from 'frontendcommon-3'
const { getMinutesFromNow } = utils.DateUtils

export function CLEAR_LOCAL_STORAGE () {
  localStorage.removeItem(STORAGE_RESET_KEY)
  localStorage.removeItem(STORAGE_SIGNUP_KEY)
  localStorage.removeItem(STORAGE_LOGIN_KEY)
}

export function SAVE_DATA_LOCAL_STORAGE (key, data) {
  localStorage.setItem(key, Crypto.encodeObj({ ...data, savedTime: new Date().getTime() }))
  return data
}

export function LOAD_STORED_DATA (key) {
  let data
  try {
    data = Crypto.decodeObj(localStorage.getItem(key))
  } catch {
    data = {}
  }
  const minutesFromNow = data.savedTime ? getMinutesFromNow(data.savedTime) : -1
  if (minutesFromNow < 0 || minutesFromNow > MAX_VALID_STORAGE_MINUTE) {
    localStorage.removeItem(key)
    data = null
  }
  return data
}

export function SAVE_STORE_LOGIN (payload) {
  SAVE_DATA_LOCAL_STORAGE(STORAGE_LOGIN_KEY, payload)
}

export function SAVE_STORE_SIGNUP (payload) {
  SAVE_DATA_LOCAL_STORAGE(STORAGE_SIGNUP_KEY, payload)
}

export function SAVE_STORE_RESET (payload) {
  SAVE_DATA_LOCAL_STORAGE(STORAGE_RESET_KEY, payload)
}

export function LOAD_SUGGESTION_DATA () {
  try {
    return Crypto.decodeObj(localStorage.getItem(STARAGE_SUGGESTIONS_KEY))
  } catch {
    return []
  }
}

export function SAVE_STORE_SUGGESTIONS (username) {
  const suggestions = LOAD_SUGGESTION_DATA()
  if (!suggestions.includes(username)) {
    suggestions.unshift(username)
    if (suggestions.length > 8) suggestions.pop()
    localStorage.setItem(STARAGE_SUGGESTIONS_KEY, Crypto.encodeObj(suggestions))
  }
}

export function CLEAN_STORE_SUGGESTIONS (suggestions) {
  const lastLogin = LOAD_STORED_DATA(STORAGE_LOGIN_KEY)
  if (lastLogin) return suggestions.filter((email) => email !== lastLogin.username)
  return suggestions
}
